import { request } from "./request";

export interface ResolveSSORequest {
  readonly resolve_id: string;
}

export interface ResolveSSOResponse {
  readonly access_token: string;
  readonly refresh_token: string;
  readonly target_url?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly attributes?: any;
  readonly offer_native_registration?: boolean;
}

export const resolveSSO = async (resolveId: string) => {
  return request<ResolveSSORequest, ResolveSSOResponse>({
    endpoint: "/sso/resolve",
    body: { resolve_id: resolveId },
    api: "authnz",
  });
};
